<template>
    <v-row no-gutters class="mb-5 bg-primary rounded-lg">
        <v-col cols="12" sm="12" md="7" lg="7" xl="7" class="bg-primary" :class="$vuetify.display.smAndDown?'rounded-t-lg':'rounded-s-lg'">
            <div class="py-5 py-md-10 py-lg-10 py-xl-10 px-6 px-md-12 px-lg-12 px-xl-12">
                <v-row no-gutters>
                    <v-col cols="12" sm="12" md="10" lg="10" xl="10">
                        <div class="pb-5 font-weight-bold custom-lineheight"
                             :class="$vuetify.display.mdAndUp?'text-h3':'custom-mobile-hero-text'"
                             v-html="$t('referrers.get_discount')"
                        >
                        </div>
                        <div class="custom-subtitle font-weight-medium">
                            {{ $t('referrers.find_out', {name: referralPartner.name}) }}
                        </div>
                        <v-list variant="text" bg-color="primary" :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'">
                            <v-list-item class="px-0">
                                <v-list-item-title class="font-weight-bold" :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'">
                                    <v-icon icon="mdi-check-circle" color="success" class="mr-3"></v-icon>
                                    {{ $t('referrers.full_black_panels') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                                <v-list-item-title class="font-weight-bold" :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'">
                                    <v-icon icon="mdi-check-circle" color="success" class="mr-3"></v-icon>
                                    {{ $t('referrers.warranty_on_inverter') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                                <v-list-item-title class="font-weight-bold" :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'">
                                    <v-icon icon="mdi-check-circle" color="success" class="mr-3"></v-icon>
                                    {{ $t('referrers.optional_battery') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-0">
                                <v-list-item-title class="font-weight-bold" :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'">
                                    <v-icon icon="mdi-check-circle" color="success" class="mr-3"></v-icon>
                                    {{ $t('referrers.installation_guarantee') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </div>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="bg-primary align-center" :class="$vuetify.display.smAndDown?'rounded-b-lg':'rounded-e-lg'">
            <div class="bg-secondary home-card__rounded-block d-flex justify-center align-center">
                <v-row no-gutters align="center">
                    <v-col cols="10" offset="1" offset-md="3" offset-lg="3" offset-xl="3" md="9" lg="9" xl="9" :class="$vuetify.display.smAndDown?'mt-16 ml-10':''">
                        <v-img aspect-ratio="1" src="/img/referral/home-card-img.png"></v-img>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: "HomeCard",
    props: {
        referralPartner: {
            type: Object
        },
    }
}
</script>

<style lang="scss">
.home-card__rounded-block {
  border-radius: 100% 8px 8px 100%;
  height: 100%;
  margin-right: -1px;
  @media (max-width: 959px) {
    border-radius: 100% 100% 8px 8px;
  }
}
.home-card__span {
  background: #F6C407;
  border-radius: 40px;
  color: #051337;
}
.custom-lineheight {
  line-height: 4rem!important;
  @media (max-width: 959px) {
    line-height: 2.75rem!important;
  }
}
.custom-subtitle {
  font-size: 18px;
  @media (max-width: 959px) {
    font-size: 14px;
  }
}
.custom-mobile-hero-text {
  @media (max-width: 959px) {
    font-size: 28px;
  }
}
</style>
